import { useSelector } from "react-redux";

const useTransferStore = () => {
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const number = useSelector((state) => state.getBranches.tel);
  return { brandId, number };
};

export default useTransferStore;
